export default defineNuxtPlugin(() => {
    // load gtag.js
    const s = document.createElement('script')
    s.async = true
    s.src = 'https://www.googletagmanager.com/gtag/js?id=G-KKL9RB8PDV'
    document.head.appendChild(s)

        // init
        ; (window as any).dataLayer = (window as any).dataLayer || []
    function gtag(...args: any[]) { ; (window as any).dataLayer.push(args) }
    gtag('js', new Date())
    gtag('config', 'G-KKL9RB8PDV')
})